import {formatTimestamp, toDate} from '../../utils/formatTimestamp';
import {normalizeWhiteboardTitle} from '../../firebase/firestore/whiteboards';

function looksLikeIsoDateTime(str) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
}

/**
 * Plain-text whiteboard name for list/detail — never formatted as a date.
 * Handles migrated Firestore payloads where `title` was a timestamp or ISO string.
 */
export function getWhiteboardDisplayTitle(whiteboard) {
    const raw = whiteboard?.title ?? whiteboard?.name;
    if (raw == null) return 'Untitled';
    if (typeof raw === 'object') {
        if (typeof raw.seconds === 'number' || typeof raw.toDate === 'function') {
            return 'Untitled';
        }
        return 'Untitled';
    }
    const str = String(raw).trim();
    if (!str || looksLikeIsoDateTime(str)) return 'Untitled';
    return normalizeWhiteboardTitle(str);
}

/**
 * Formats various value types for display in the table.
 * @param {*} value - The value to format
 * @returns {string} Formatted value
 */
export const formatValue = (value) => {
    if (value === null || value === undefined) return '-';
    const d = toDate(value);
    if (d) return formatTimestamp(d, '-');
    return String(value);
};

/**
 * Gets a nested value from an object using dot notation
 * @param {Object} obj - The object to traverse
 * @param {string} path - Dot-separated path (e.g., 'user.profile.name')
 * @returns {*} The nested value or undefined
 */
export const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split('.').reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        obj
    );
};

